export default __webpack_public_path__ + "static/media/headerLogo.bae74c2a.png";